import { Bill, Invoice, InvoiceType, InvoicingSummary } from '../entities/invoicing/invoicing';
import { InvoiceStatus } from '../entities/invoicing/invoicing.enum';
import { InvoiceCalculationDomain } from '../entities/invoicing/invoice.calculation.domain';

// Settled-state rule: only an Approved record qualifies. Credit notes gate payment differently
// (isFullyPaid() is always true) so they settle when no credit remains; everything else uses isFullyPaid().
export function isInvoicePaid(item: Bill | Invoice | InvoicingSummary): boolean {

    if (!item || item?.status !== InvoiceStatus.Approved) {
        return false;
    }

    const isBill = [InvoiceType.Bill, InvoiceType.PrepaymentSupplier, InvoiceType.CreditNoteSupplier].includes(item.type);
    // A copy: the domain defaults missing money fields onto what it is given, and a predicate must not
    // write to its input. Handed a live surface model it dirtied an untouched Approved bill (WBS-11970).
    const domain = InvoiceCalculationDomain.from({ ...item }, isBill);

    if (domain.isType(InvoiceType.CreditNote) || domain.isType(InvoiceType.CreditNoteSupplier)) {
        return domain.getRemainingCredit() === 0;
    }

    // Nothing outstanding is not the same as paid: a $0 Bill or Invoice with no payment recorded would
    // otherwise wear a Paid pill it never earned, and read as settled and locked when it is neither.
    const paid = item as { amountPaid?: number; hasPayments?: boolean };
    if (!paid.hasPayments && !(Number(paid.amountPaid ?? 0) > 0)) {
        return false;
    }

    return domain.isFullyPaid();
}
